import MochipayRouter from "app-router/mochipay/mochipay-router";

export default MochipayRouter
